import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addproposaltowishlist } from "../../../../../../../redux/posts/action";
import PostNotFound from "../../../../../../CustomComponents/AllLoader/PostNotFound";
import ViewProfilePopup from "../../../../../../Common/ViewProfilePopup";
import HireRequestModel from "../../../../../../Common/HireRequestModel";
import { hitPostChat } from "../../../../../../../redux/chatandnotification/action";
import ProfilePic from "../../../../../../../assests/imgs/Profileplaceholder.svg";
import RoleLabel from "../../../../../../Common/RoleLabel";
import CustomReactQuillDescription from "../../../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";

export default function MineJobAllProposals({ posts, directpayment }) {
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [proid, setproid] = useState("");
  const [proposal, setProposal] = useState([]);
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [profiledetails, setprofiledetails] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [filteredProposals, setFilteredProposals] = useState([]);

  const hireExpert = (id) => {
    // navigate(`/${lan}/jobcontract/${id}`);
    setModal1(true);
    setproid(id);
  };
  const comformhireExpert = (id) => {
    navigate(`/${lan}/jobcontract/${id}`);
  };

  const letChat = (item) => {
    const data = {
      post_id: posts?.id,
      user_id: item?.user_id,
    };
    const hitcatapidata = {
      type: "1",
      post_id: posts?.id,
      user_id: item?.user_id,
      message: "",
      image: "",
    };

    // dispatch(hitPostChat(hitcatapidata, setLoading));
    navigate(`/${lan}/account/chats/`, { state: { userdetails: data } });
  };

  const saveToWishlist = (id) => {
    dispatch(addproposaltowishlist(id, posts?.id));
  };

  useEffect(() => {
    const filteredProposals =
      posts?.proposal?.filter((item) => item.wishlist == 1) || [];
    setFilteredProposals(filteredProposals);
  }, [posts]);

  const viewprofile = (item) => {
    setModal(true);
    setprofiledetails(item);
  };

  return (
    <div className="project-section project-details p-0">
      {modal && (
        <ViewProfilePopup
          profiledetails={profiledetails}
          setModal={setModal}
          modal={modal}
          comformhireExpert={comformhireExpert}
        />
      )}
      {modal1 && (
        <HireRequestModel
          posts={posts}
          setModal1={setModal1}
          modal1={modal1}
          proid={proid}
        />
      )}
      <div className="post-details">
        <div className="all-proposal-row">
          {Array.isArray(filteredProposals) && filteredProposals.length > 0 ? (
            filteredProposals.map((item, index) => (
              <div className="all-proposal" key={index}>
                <div className="proposal-first proposal-wrap">
                  <div className="proposal-left">
                    <img
                      onClick={() => viewprofile(item)}
                      src={item?.profile_image ? item?.profile_image : ProfilePic}
                      alt=""
                    />
                    <div>
                      <h5>
                        {item?.first_name} {item?.last_name}
                        <span>
                          <i className="fa-solid fa-star"></i>
                          {item?.expert_rating || 0} ({item?.expert_comment_count || 0} reviews)
                        </span>
                      </h5>
                      <p>{item?.designation}</p>
                    </div>
                  </div>
                  <div className="expert-right">
                    <button
                      className="btn message-btn"
                      onClick={() => {
                        letChat(item?.id);
                      }}
                    >
                      Chat with <RoleLabel role_type={item?.role_type} />
                    </button>
                    <button
                      disabled={item?.status != 21}
                      className="btn message-btn active"
                      onClick={() => {
                        comformhireExpert(item?.id);
                      }}
                    >
                      {item?.status == 21
                        ? "Send Offer"
                        : item?.status == 22
                          ? "You declined"
                          : item?.status == 23
                            ? "Offer Sent"
                            : item?.status == 24
                              ? "Offer Declined"
                              : item?.status == 25
                                ? "Offer Accepeted"
                                : "Send Offer"}
                    </button>
                    {
                      (item?.status != "21" && item?.payment_status == 0) &&
                      <button
                        className="btn message-btn active"
                        onClick={() => {
                          directpayment(item);
                        }}
                      >
                        Pay
                      </button>
                    }
                    <button
                      className="btn menu-btn"
                      onClick={() => {
                        saveToWishlist(item?.id);
                      }}
                    >
                      {item.wishlist == 1 ? (
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                          alt=""
                        />
                      ) : (
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                          alt=""
                        />
                      )}
                    </button>
                  </div>
                </div>
                <h3>Cover letter</h3>  
                <p className="cover-p"><CustomReactQuillDescription value={item?.message} /></p>

                <div className="photoshop">
                  {Array.isArray(item?.skills) &&
                    item.skills.map((skill, index) => (
                      <p key={index}>{skill?.title}</p>
                    ))}
                </div>
              </div>
            ))
          ) : (
            <PostNotFound title={"Proposal not found"} />
          )}
        </div>
      </div>
    </div>
  );
}
